module.exports = __webpack_public_path__ + "img/Pendant Twisting.c1656d6c.png";